import { useEffect, useState } from "react";

export interface AreaNode {
    id: string;
    name: string;
    childs?: AreaNode[];
}

let cachedAreas: AreaNode[] | undefined;
let areaRequest: Promise<AreaNode[]> | undefined;

/** 地区数据源与旧 Vue areaLib 保持一致，并在页面间复用请求结果。 */
export function loadAreas() {
    if (cachedAreas) return Promise.resolve(cachedAreas);
    areaRequest ??= fetch("https://static.zhihaoscm.cn/map/areas.json")
        .then(response => response.json() as Promise<AreaNode[]>)
        .then(areas => {
            cachedAreas = areas;
            return areas;
        })
        .catch(() => []);
    return areaRequest;
}

/** 按旧版三级 areaLib 规则把行政区代码转换为完整名称。 */
function getFullAreaName(areas: AreaNode[], province?: string, city?: string, district?: string) {
    const provinceNode = areas.find(item => item.id === province);
    if (!provinceNode) return [province, city, district].filter(Boolean).join("");
    const cityNode = provinceNode.childs?.find(item => item.id === city);
    const districtNode = cityNode?.childs?.find(item => item.id === district);
    return [provinceNode.name, cityNode?.name, districtNode?.name].filter(Boolean).join("");
}

/** 异步加载地区库后返回完整省市区名称；加载前不闪现行政区代码。 */
export function useFullAreaName(province?: string, city?: string, district?: string) {
    const literalName = province && !/^\d+$/.test(province) ? [province, city, district].filter(Boolean).join("") : "";
    const [name, setName] = useState(() => literalName || (cachedAreas ? getFullAreaName(cachedAreas, province, city, district) : ""));
    useEffect(() => {
        if (!province) {
            setName("");
            return;
        }
        // 接口部分场景已返回地区名称，此时不再访问地区库。
        if (literalName) {
            setName(literalName);
            return;
        }
        let active = true;
        void loadAreas().then(areas => {
            if (active) setName(getFullAreaName(areas, province, city, district));
        });
        return () => {
            active = false;
        };
    }, [province, city, district, literalName]);
    return name;
}
